// src/tenantloader/AuthContextProvider.js - Tenant-aware Auth wrapper
// This acts as a bridge between shared components and tenant-specific auth

import { loadTenantAuthContext } from './TenantLoader';

// Load tenant-specific AuthContext
const tenantAuthContext = loadTenantAuthContext();

// Re-export the useAuth hook from the tenant-specific AuthContext
export const useAuth = tenantAuthContext.useAuth;
export const AuthProvider = tenantAuthContext.AuthProvider;
